import queryString from 'query-string';

export const getFileIdFromUrl = () => {
  // https://pdfguru.com/app/v1/editor?documentId=14039 or https://pdfguru.com/app/v1/editor?file=14039
  const parsed = queryString.parse(window.location.search);
  const documentId = parsed?.['documentId'] || parsed?.['file'];

  return documentId && documentId !== null ? documentId : '';
};

const STATIC_FILE_ID_QUERY_PARAM_NAME = 'staticFileId';

export const getStaticFileIdFromUrl = () => {
  // https://pdfguru.com/app/v1/editor?staticFileId=705313b9-ba91-459b-a696-cc73b72c99ff
  const parsed = queryString.parse(window.location.search);
  const staticFileId = parsed?.[STATIC_FILE_ID_QUERY_PARAM_NAME];

  return staticFileId && staticFileId !== null ? staticFileId : '';
};

export const getFormNameFromUrl = () => {
  // https://pdfguru.com/app/v1/editor?form=14039
  const parsed = queryString.parse(window.location.search);

  return parsed?.['form'] || '';
};
